import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatProgressBar } from '@angular/material/progress-bar'

import { ScheduleVehicleService } from '../../../core/services/schedule/schedule-vehicle/schedule-vehicle.service'
import { MonitoringService } from '../../../core/services/monitoring/monitoring.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { LinhaMonitoramentoVm } from '../../../core/models/monitoring-os.model'

// Mesma regra do modal de motorista: só troca o veículo. Chama
// Monitoramento/{osId}/atribuir (sprint 9/10, seção 06) — o back decide
// create/edit pelo agendaId enviado.
@Component({
  selector: 'modal-alterar-veiculo',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinner,
    MatProgressBar,
  ],
  templateUrl: './modal-alterar-veiculo.component.html',
  styleUrl: './modal-alterar-veiculo.component.scss',
})
export class ModalAlterarVeiculoComponent implements OnInit {
  @Output() response = new EventEmitter<boolean>()

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { item: LinhaMonitoramentoVm },
    private dialogRef: MatDialogRef<ModalAlterarVeiculoComponent>,
    private scheduleVehicleService: ScheduleVehicleService,
    private monitoringService: MonitoringService,
    private snackbar: SnackbarCustomService,
  ) {}

  veiculos: any[] = []
  loading = false
  salvandoId: number | null = null
  busca = ''

  ngOnInit(): void {
    this.carregar()
  }

  carregar(): void {
    this.loading = true
    this.scheduleVehicleService
      .listPagedFreeVehicles(1, 100, { ordemServicoId: this.data.item.codigoOs })
      .subscribe({
        next: (res: any) => {
          this.veiculos = Array.isArray(res.data) ? res.data : []
          this.loading = false
        },
        error: (err: any) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
      })
  }

  get veiculosFiltrados(): any[] {
    const termo = this.busca.trim().toLowerCase()
    if (!termo) return this.veiculos
    return this.veiculos.filter(
      (v) =>
        (v.placa ?? '').toLowerCase().includes(termo) || (v.modelo ?? '').toLowerCase().includes(termo),
    )
  }

  selecionar(veiculo: any): void {
    this.salvandoId = veiculo.id
    const item = this.data.item

    this.monitoringService.atribuir(item.codigoOs, {
      veiculoId: veiculo.id,
      agendaVeiculoId: item.veiculo?.agendaId ?? null,
    }).subscribe({
      next: (res: any) => {
        this.salvandoId = null
        this.snackbar.success(res.message ?? 'Veículo alterado com sucesso.')
        this.response.emit(true)
        this.dialogRef.close()
      },
      error: (err: any) => {
        this.salvandoId = null
        this.snackbar.errorRequest(err)
      },
    })
  }

  close(): void {
    this.dialogRef.close()
  }
}
